import { Clock, CalendarDays } from "lucide-react";
import { Reveal, SectionHeader } from "../Reveal";
import { SCHEDULES, WEEK_DAYS } from "../../lib/data";

export const FunnelSchedule = () => (
    <section id="schedule" className="relative bg-noir py-24 sm:py-32 overflow-hidden" data-testid="funnel-schedule">
        <div className="absolute -top-20 right-1/4 h-[380px] w-[380px] rounded-full bg-hotpink/8 blur-[130px]" aria-hidden="true" />
        <div className="relative mx-auto max-w-[1400px] px-4 sm:px-6">
            <SectionHeader
                eyebrow="CAMPAIGN SCHEDULING"
                title={<>CHOOSE YOUR <span className="text-chrome-gradient">ADVERTISING SCHEDULE.</span></>}
                sub="Select a recommended schedule — or request a custom one — when you request your quote."
            />

            <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-5">
                {SCHEDULES.map((s, i) => (
                    <Reveal key={s.id} delay={i * 0.07} className="h-full">
                        <article
                            className={`relative flex h-full flex-col rounded-2xl p-6 border transition-all duration-300 hover:-translate-y-1.5 ${
                                s.recommended
                                    ? "bg-noir-elevated border-hotpink led-glow"
                                    : "glass-panel hover:border-white/25"
                            }`}
                            data-testid={`schedule-card-${s.id}`}
                        >
                            {s.recommended && (
                                <span className="absolute -top-3 left-5 rounded-full bg-hotpink px-3.5 py-1 font-alt text-[9px] font-bold tracking-[0.22em] text-noir">
                                    RECOMMENDED
                                </span>
                            )}
                            <Clock size={20} className="text-hotpink" />
                            <h3 className="mt-4 font-alt text-[13px] font-bold tracking-[0.16em] text-white">{s.name}</h3>
                            <p className="mt-2 text-[12px] leading-relaxed text-zinc-400">{s.desc}</p>
                            {s.slots.length > 0 && (
                                <ul className="mt-4 space-y-2">
                                    {s.slots.map((slot) => (
                                        <li key={slot} className="rounded-lg border border-white/12 bg-white/[0.05] px-3 py-2 text-center font-alt text-[11px] font-bold tracking-[0.1em] text-zinc-200">
                                            {slot}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {s.recommended && (
                                <p className="mt-4 rounded-lg border border-hotpink/40 bg-hotpink/10 px-3 py-2 text-center font-alt text-[11px] font-bold tracking-[0.1em] text-hotpink">
                                    OPTIMIZED FOR MAXIMUM IMPRESSIONS
                                </p>
                            )}
                        </article>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.15}>
                <div className="mt-6 glass-panel p-6 sm:p-8" data-testid="custom-schedule-card">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-5">
                        <CalendarDays size={22} className="text-hotpink shrink-0" />
                        <div className="flex-1">
                            <h3 className="font-alt text-[13px] font-bold tracking-[0.16em] text-white">CUSTOM SCHEDULE</h3>
                            <p className="mt-1.5 text-[13px] text-zinc-400">Pick your days, start time, and end time — include it in your quote request message.</p>
                        </div>
                        <div className="flex flex-wrap gap-1.5">
                            {WEEK_DAYS.map((d) => (
                                <span key={d} className="rounded-md border border-white/12 bg-white/[0.05] px-2.5 py-1 font-alt text-[10px] font-semibold tracking-wider text-zinc-300">
                                    {d.slice(0, 3).toUpperCase()}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </Reveal>

            <Reveal delay={0.2}>
                <p className="mt-8 text-center font-alt text-[10px] font-bold tracking-[0.22em] text-hotpink uppercase" data-testid="schedules-disclaimer">
                    All schedules are subject to network inventory, availability, and confirmation.
                </p>
            </Reveal>
        </div>
    </section>
);
